import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CheckLivraisonsResult, CheckLivraisonsService } from '../../../services/check-livraisons.service';

@Component({
  selector: 'app-verifier-livraisons',
  imports: [CommonModule, RouterLink],
  templateUrl: './verifier-livraisons.component.html',
  styleUrl: './verifier-livraisons.component.scss'
})
export class VerifierLivraisonsComponent {
  protected running = false;
  protected result: CheckLivraisonsResult | null = null;
  protected error = '';
  protected lastRunAt: Date | null = null;

  constructor(
    private readonly checkLivraisonsService: CheckLivraisonsService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  protected async runCheck(): Promise<void> {
    if (this.running) {
      return;
    }

    this.running = true;
    this.error = '';
    this.cdr.markForCheck();

    try {
      this.result = await this.checkLivraisonsService.runCheckLivraisons(false);
      this.lastRunAt = new Date();
    } catch (err: any) {
      this.error = this.extractErrorMessage(err);
    } finally {
      this.running = false;
      this.cdr.markForCheck();
    }
  }

  private extractErrorMessage(err: any): string {
    if (typeof err?.error === 'string' && err.error.trim()) {
      return err.error;
    }
    if (err?.error?.detail) {
      return String(err.error.detail);
    }
    if (err?.error?.message) {
      return String(err.error.message);
    }
    if (err?.message) {
      return String(err.message);
    }
    return 'Erreur inconnue';
  }
}
